export const EMPTY = 'empty'
export const SHOP = 'shop'
export const AUTO_WASH = 'autoWash'
export const botTypes = {
  [EMPTY]: 1,
  [SHOP]: 2,
  [AUTO_WASH]: 3,
}
export const botTitles = {
  [EMPTY]: 'Обычный',
  [SHOP]: 'Магазин',
  [AUTO_WASH]: 'Автомойка',
}

export function getBotTypeTitle(type) {
  return botTitles[type]
}

export function getBotTypeId(type) {
  return botTypes[type]
}
